export default "\n    <div *ngIf=\"type == 'card'\" id=\"card-container\"></div>\n    <div  *ngIf=\"type == 'giftcard'\" id=\"idGiftCard\"></div>"